import * as React from "react";
import { Skeleton, Empty } from "antd";
import { API } from "General/API";
import { projectsDataStore } from "Stores";
import { fileDetailsStore } from "../FileDetailsStore";
import { API_URL } from "General/APIEndpoints";
import { withTranslation, WithTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { I18N_NS } from "Config/i18n";
import { ChangeMetadata } from "./ChangeMetadata";
import { Table } from "Components/General/Table";

interface MetadataProps extends WithTranslation {}

interface MetadataState {
  data: API_FileMetadata[];
  loading: boolean;
}

export const Metadata = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<MetadataProps, MetadataState> {
      constructor(props: MetadataProps) {
        super(props);

        this.state = {
          data: [],
          loading: false,
        };
      }

      componentDidMount() {
        (async () => await this.handleFetch())();
      }

      handleFetch = async () => {
        try {
          const response = await API.getData(
            API_URL.FILES.getFileMetadata_1(projectsDataStore.projectId, fileDetailsStore.fileId)
          );
          this.setState({ data: response });
        } catch (error) {
          throw error;
        }
      };

      render() {
        const { data, loading } = this.state;
        const { t } = this.props;

        return (
          <Skeleton loading={loading}>
            {data.length === 0 ? (
              <Empty />
            ) : (
              <div className="mb-md">
                <Table
                  name="fileMetadata"
                  dataSource={data}
                  rowKey="id"
                  pagination={false}
                  size="small"
                  columns={[
                    { dataIndex: "key", title: t("Name") },
                    { dataIndex: "description", title: t("Description") },
                    { dataIndex: "value", title: t("Value") },
                    { dataIndex: "valueDescription", title: t("Value description") },
                  ]}
                />
              </div>
            )}
            <ChangeMetadata reFetch={this.handleFetch} fileMetadata={data} disabled={loading} />
          </Skeleton>
        );
      }
    }
  )
);
